var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCantListen = function SvgCantListen(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.8685V10.4378C1 9.25266 1.9402 8.29188 3.1 8.29188H3.282C3.94557 8.29259 4.60427 8.17609 5.229 7.94751L9.146 4.51707C9.52664 4.18346 10.0115 4 10.513 4C11.2437 4 11.836 4.60529 11.836 5.35194V16.9543C11.836 17.701 11.2437 18.3063 10.513 18.3063C10.0115 18.3063 9.52664 18.1228 9.146 17.7892L5.229 14.3588C4.60427 14.1302 3.94557 14.0137 3.282 14.0144H3.1C1.9402 14.0144 1 13.0536 1 11.8685Z",
    fill: "#A5D6D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8839 9.88388C21.372 9.39573 21.372 8.60427 20.8839 8.11612C20.3957 7.62796 19.6043 7.62796 19.1161 8.11612L17.5 9.73223L15.8839 8.11612C15.3957 7.62796 14.6043 7.62796 14.1161 8.11612C13.628 8.60427 13.628 9.39573 14.1161 9.88388L15.7322 11.5L14.1161 13.1161C13.628 13.6043 13.628 14.3957 14.1161 14.8839C14.6043 15.372 15.3957 15.372 15.8839 14.8839L17.5 13.2678L19.1161 14.8839C19.6043 15.372 20.3957 15.372 20.8839 14.8839C21.372 14.3957 21.372 13.6043 20.8839 13.1161L19.2678 11.5L20.8839 9.88388Z",
    fill: "#A5D6D3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCantListen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/cantListen.aa8bf9c45dd3f9cf4a4e1d061402b7ad.blank.svg";